// ---------------------------------------------- modules import
import React, { FunctionComponent, createContext } from "react";

import { IThemeContextProviderState } from "./common";
import { useThemeContext } from "./hooks";
import { newTheme } from "../store/helpers/themeHelper";

// ---------------------------------------------- create context
const initialState: IThemeContextProviderState = {
  theme: newTheme()
};

export const ThemeContext = createContext(initialState);

// ---------------------------------------------- the component
const ThemeContextProvider: FunctionComponent = ({ children }) => {
  // ---------------------------------------------- local state
  const { theme, onChange } = useThemeContext();

  // ---------------------------------------------- content
  return (
    <ThemeContext.Provider value={{ theme, onChange }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
